import { RecoveryScreen, type RecoveryScreenProps } from './RecoveryScreen';

/**
 * Shown instead of the app when the local database could not be prepared for the
 * signed-in user — the clear that hands the cache from one account to the next
 * failed, so it may still hold the previous user's rows. Every screen queries local
 * SQLite directly, so rendering the app here would show them.
 */
export function StaleCacheScreen({
  onRetry,
  onSignOut,
}: Pick<RecoveryScreenProps, 'onRetry' | 'onSignOut'>) {
  return (
    <RecoveryScreen
      icon="🔒"
      title="Couldn't load your data"
      body="This device still holds data from a previous session, and it couldn't be cleared. Try again, or sign out to start fresh."
      onRetry={onRetry}
      onSignOut={onSignOut}
    />
  );
}
